var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13595_75702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4C10 3.60603 9.9224 3.21593 9.77164 2.85195C9.62087 2.48797 9.3999 2.15726 9.12132 1.87868C8.84274 1.6001 8.51203 1.37913 8.14805 1.22836C7.78407 1.0776 7.39397 1 7 1C6.60603 1 6.21593 1.0776 5.85195 1.22836C5.48797 1.37913 5.15726 1.6001 4.87868 1.87868C4.6001 2.15726 4.37913 2.48797 4.22836 2.85195C4.0776 3.21593 4 3.60603 4 4C4 4.39397 4.0776 4.78407 4.22836 5.14805C4.37913 5.51203 4.6001 5.84274 4.87868 6.12132C5.15726 6.3999 5.48797 6.62087 5.85195 6.77164C6.21593 6.9224 6.60603 7 7 7C7.39397 7 7.78407 6.9224 8.14805 6.77164C8.51203 6.62087 8.84274 6.3999 9.12132 6.12132C9.3999 5.84274 9.62087 5.51203 9.77164 5.14805C9.9224 4.78407 10 4.39397 10 4ZM3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4C11 5.06087 10.5786 6.07828 9.82843 6.82843C9.07828 7.57857 8.06087 8 7 8C5.93913 8 4.92172 7.57857 4.17157 6.82843C3.42143 6.07828 3 5.06087 3 4ZM1.35312 15H12.6438L11.2625 10.5H2.7375L1.35312 15ZM2 9.5H12L13.6938 15L14 16H12.9531H1.04688H0L0.30625 15L2 9.5Z",
    fill: "#1D1F2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13595_75702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3c57ffe69d4d3b929ec7f85038a721f1.svg";
export { ForwardRef as ReactComponent };